import React from 'react';
import {IElementQuestionMatchPair} from '../../../../incase-domain/elements/question/questionMatchPair';
import MatchPairQuestionItems from './MatchPairQuestionItems';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import QuestionLayout from '../common/QuestionLayout';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';

function MatchPairQuestionElement(props: IQuestionElementProps<IElementQuestionMatchPair>): JSX.Element {
    const {element, device = DeviceType.DESKTOP} = props;

    return (
        <QuestionLayout element={element} device={device} showConfirmButton={element.haveTryButton}>
            <MatchPairQuestionItems element={element} device={device} />
        </QuestionLayout>
    );
}

export default MatchPairQuestionElement;
